/***java端接口************/
import request from ".././appRequest";

let clouder = "/cloudWisdom";
// let clouder = "";

/***集团共享************************************************************************/
/***客户管理*********************************/
// 经营管理待更新-列表
export function getCustomerScopeList(params) {
  return request({
    url: clouder + `/cloud/customer/getCustomerScopeList`,
    method: "get",
    params,
  });
}
// 获取客户匹配信息（手动匹配客户弹窗）
export function getCustomerMatchInfo(params) {
  return request({
    url: clouder + `/cloud/customer/getCustomerMatchInfo`,
    method: "get",
    params,
  });
}
// 手动匹配客户（确认匹配）
export function updateMatchInfo(data) {
  return request({
    url: clouder + `/cloud/customer/updateMatchInfo`,
    method: "post",
    data,
  });
}
// 集团客户-列表
export function getCustomerList(params) {
  return request({
    url: clouder + `/cloud/customer/getCustomerList`,
    method: "get",
    params,
  });
}
// 集团客户-上次勾选供应商名单
export function getLastSelectedBusinessList(params) {
  return request({
    url: clouder + `/cloud/customer/getLastSelectedBusinessList`,
    method: "get",
    params,
  });
}
// 集团客户-启用禁用集团客户
export function statusCustomer(data) {
  return request({
    url: clouder + `/cloud/customer/statusCustomer`,
    method: "post",
    data,
  });
}
// 集团客户-集团客户资质详情
export function getCustomerDetail(params) {
  return request({
    url: clouder + `/cloud/customer/getCustomerDetail`,
    method: "get",
    params,
  });
}
// 集团客户-获取连锁总部标识列表
export function getChainHeadquartersList(params) {
  return request({
    url: clouder + `/cloud/customer/getChainHeadquartersList`,
    method: "get",
    params,
  });
}
// 集团客户-新建连锁总部
export function addChainHeadquarter(data) {
  return request({
    url: clouder + `/cloud/basic/addHeadquarter`,
    method: "post",
    data,
  });
}
// 集团客户-获取地区树
export function getDistrictList(params) {
  return request({
    url: clouder + `/cloud/basic/getDistrictList`,
    method: "get",
    params,
  });
}
// 集团客户-获取会员类型列表
export function getUserTypes(params) {
  return request({
    url: clouder + `/cloud/basic/getUserTypes`,
    method: "get",
    params,
  });
}
// 集团客户-获取平台经营范围
export function getScopeList(params) {
  return request({
    url: clouder + `/cloud/customer/getScopeList`,
    method: "get",
    params,
  });
}
// 集团客户-客户信息编辑
export function updateOperationManagementInfo(data) {
  return request({
    url: clouder + `/cloud/customer/updateOperationManagementInfo`,
    method: "post",
    data,
  });
}
// 集团客户-共享发送
export function shareSend(data) {
  return request({
    url: clouder + `/cloud/customer/shareSend`,
    method: "post",
    data,
  });
}
// 集团客户-推送资质给ERP
export function erpSendQualification(data) {
  return request({
    url: clouder + `/cloud/customer/erpSendQualification`,
    method: "post",
    data,
  });
}
// 推送记录-列表
export function getPushRecord(params) {
  return request({
    url: clouder + `/cloud/customer/getPushRecord`,
    method: "get",
    params,
  });
}
// 推送记录-重新推送
export function retrySendQualification(data) {
  return request({
    url: clouder + `/cloud/customer/retrySendQualification`,
    method: "post",
    data,
  });
}
// 共享发送/接收记录(列表)
export function getQualificationShareRecord(params) {
  return request({
    url: clouder + `/cloud/customer/getQualificationShareRecord`,
    method: "get",
    params,
  });
}
// 共享接收记录-审核
export function receiveAudit(data) {
  return request({
    url: clouder + `/cloud/customer/receiveAudit`,
    method: "post",
    data,
  });
}
// 共享接收记录-批量审核
export function batchReceiveAudit(data) {
  return request({
    url: clouder + `/cloud/customer/batchReceiveAudit`,
    method: "post",
    data,
  });
}
/***数据统计*********************************/
// 客户数据统计列表
export function getCustomerStatisticsList(params) {
  return request({
    url: clouder + `/cloud/data/getCustomerStatisticsList`,
    method: "get",
    params,
  });
}
/***基础设置*********************************/
// 集团管理-子公司列表
export function getCompanyList(params) {
  return request({
    url: clouder + `/cloud/basic/getCompanyList`,
    method: "get",
    params,
  });
}
// 集团管理-子公司列表（不分页）
export function getCompany(params) {
  return request({
    url: clouder + `/cloud/basic/getCompany`,
    method: "get",
    params,
  });
}
// 集团管理-添加集团公司子公司
export function addCompany(data) {
  return request({
    url: clouder + `/cloud/basic/addCompany` + `?businessId=${data.businessId}`,
    method: "post",
    data,
  });
}
// 集团管理-编辑集团公司子公司
export function editCompany(data) {
  return request({
    url:
      clouder + `/cloud/basic/editCompany` + `?businessId=${data.businessId}`,
    method: "post",
    data,
  });
}
// 集团管理-启用禁用集团公司子公司
export function statusCompany(data) {
  return request({
    url: clouder + `/cloud/basic/statusCompany`,
    method: "post",
    data,
  });
}
// 获取登录用户信息
export function getUserInfo(params) {
  return request({
    url: clouder + `/cloud/basic/getUserInfo`,
    method: "get",
    params,
  });
}

// 变更日志记录列表
export function getChangeLogList(params) {
  return request({
    url: clouder + `/cloud/basic/getChangeLogList`,
    method: "get",
    params,
  });
}
// 对码管理-对码列表
export function getMatchingCodeList(params) {
  return request({
    url: clouder + `/cloud/basic/getMatchingCodeList`,
    method: "get",
    params,
  });
}
// 对码管理-手动对码
export function editMatchingCode(data, params) {
  return request({
    url: clouder + `/cloud/basic/editMatchingCode`,
    method: "post",
    data,
    params,
  });
}
